import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-731d7227"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "login-screen",
  class: "bg-white p-8 rounded-2xl border border-gray-200 max-w-sm w-full mx-auto my-16"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-center text-gray-800 mb-6" }, "Giriş Yap", -1))
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "tc",
  class: "block text-gray-700 font-medium mb-2"
}, "Öğrenci TC Kimlik No (Son 4 Hane)", -1))
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-gray-700 font-medium mb-2"
}, "Veli Cep Telefonu Numarası", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full bg-gray-900 text-white px-6 py-3 rounded-lg shadow-md hover:bg-gray-950"
}, " Giriş Yap ", -1))
const _hoisted_8 = {
  key: 0,
  class: "text-red-500 mt-4 text-center"
}
const _hoisted_9 = {
  key: 1,
  id: "otp-screen",
  class: "bg-white p-8 rounded-2xl border border-gray-200 max-w-sm w-full mx-auto my-16"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-center text-gray-800 mb-6" }, "OTP Onayla", -1))
const _hoisted_11 = { class: "mb-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "otp",
  class: "block text-gray-700 font-medium mb-2"
}, "Tek Seferlik Şifre", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full bg-gray-900 text-white px-6 py-3 rounded-lg shadow-md hover:bg-gray-950 transition duration-300"
}, " Onayla ", -1))
const _hoisted_14 = {
  key: 0,
  class: "text-red-500 mt-4 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaskInput = _resolveComponent("MaskInput")!

  return (!_ctx.isLoggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          id: "login-form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "tc",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tc) = $event)),
              maxlength: "4",
              class: "w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
              placeholder: "1234",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.tc]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_MaskInput, {
              mask: "(###) ### ## ##",
              modelValue: _ctx.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event)),
              type: "text",
              class: "w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
              placeholder: "(555) 555 55 55",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_7
        ], 32),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("form", {
          id: "otp-form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleOtp && _ctx.handleOtp(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "otp",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.otp) = $event)),
              class: "w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
              placeholder: "OTP",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.otp]
            ])
          ]),
          _hoisted_13
        ], 32),
        (_ctx.otpErrorMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.otpErrorMessage), 1))
          : _createCommentVNode("", true)
      ]))
}